import { IReduxAction, actionGenerator } from '../../utils/actions';

export const SET_TERMS_DURATION = 'TERMS_DURATIONS :: DURATION';

export type TSetTermsDurationAction = IReduxAction<typeof SET_TERMS_DURATION, number>;

export const setTermsDuration = actionGenerator<typeof SET_TERMS_DURATION, number>(SET_TERMS_DURATION);
